module.exports = __webpack_public_path__ + "img/info.3818c337.svg";